import React from 'react';


import { Offcanvas } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
// import Collapsible from 'react-collapsible';
import { BiMap } from 'react-icons/bi';
import { FaEnvelope, FaPhoneAlt } from 'react-icons/fa';
import { useTranslation } from "react-i18next";

import { businessLogic } from "../../lib/constants";


const Sidebar = ({ show, handleClose }) => {
   const { t } = useTranslation();

   return (
      <>

         <div >
            <Offcanvas show={show} onHide={handleClose} placement='end' className='side__bar'>
               <Offcanvas.Header closeButton>
                  <div className="logo pt-50">
                        <img src={`/assets/img/logo/${businessLogic.logoBlack}`} alt="logo" height={35}/>
                  </div>
               </Offcanvas.Header>

               <Offcanvas.Body>


                  <section>
                     <div className="p-0">
                        <div className="sidebar__tab">
                           <ul className="nav nav-tabs" id="sidebar-tab" role="tablist">
                              <li className="nav-item">
                                 <a className="nav-link active" id="menu-tab" data-bs-toggle="tab" href="#menu" role="tab" aria-controls="menu" aria-selected="true">menu</a>
                              </li>
                              <li className="nav-item">
                                 <a className="nav-link" id="info-tab" data-bs-toggle="tab" href="#info" role="tab" aria-controls="info" aria-selected="false">info</a>
                              </li>
                           </ul>
                        </div>
                        <div className="sidebar__content">

                           <div className="tab-content" id="sidebar-tab-content">
                              <div className="tab-pane fade show active" id="menu" role="tabpanel" aria-labelledby="menu-tab">

                                 <div className='side_navBar'>



                                    {/* Este menú es el ÚNICO por debajo de 992 px, así que debe
                                        reflejar el de escritorio (HomeOneHeader) y estar traducido.
                                        Antes venía tal cual de la plantilla comprada: en inglés,
                                        con rutas que ya no son las del sitio y sin el CTA. */}
                                    <div className='about iconAdd'>
                                       <NavLink to="/about" onClick={handleClose}>{t("navbar_about_us")}</NavLink>
                                   </div>

                                   <div className='about iconAdd'>
                                       <NavLink to="/services" onClick={handleClose}>{t("navbar_services")}</NavLink>
                                   </div>

                                   {/* Marca Blanca: entrada OCULTA del navbar (la ruta /activation sigue activa) */}

                                   <div className='about iconAdd'>
                                       <NavLink to="/get-started" onClick={handleClose}>{t("gs_page_title")}</NavLink>
                                   </div>

                                   <div className='about iconAdd'>
                                       <NavLink to="/playbooks" onClick={handleClose}>Playbooks</NavLink>
                                   </div>

                                   <div className='about iconAdd'>
                                       <NavLink to="/pricing" onClick={handleClose}>{t("home_techgrid_cta_secondary")}</NavLink>
                                   </div>

                                    <div className='about iconAdd'>
                                        <a href="/blog">{t("navbar_blog")}</a>
                                    </div>

                                   <div className='about iconAdd border-0'>
                                       <NavLink to="/contact" onClick={handleClose}>{t("contact_us")}</NavLink>
                                    </div>

                                    <div className='mt-25'>
                                       <NavLink to="/demo" className="z-btn" onClick={handleClose}>{t("demo_cta")}</NavLink>
                                    </div>



                                    {/* <Collapsible trigger={<NavLink to="/home">Home</NavLink>} triggerTagName="div"
                                       triggerOpenedClassName="icon_close" triggerClassName="iconAdd" open={false}>
                                       <ul className="sidebar_sub_menu text-white">

                                          <li className='pt-10'><NavLink to="/home">Home style 1</NavLink></li>

                                          <Collapsible trigger={<li className='border-0'><NavLink to="/homeTwo">Home style 2</NavLink> </li>} triggerTagName="div" triggerOpenedClassName="sub_child icon_close" triggerClassName="sub_child iconAdd" open={false}>
                                             <ul className="sidebar_sub_menu sub_child_menu submenu text-white">
                                                <li><NavLink to="/home">Home Style 1</NavLink></li>
                                                <li><NavLink to="/homeTwo">Home Style 2</NavLink></li>
                                                <li><NavLink to="/homeThree">Home Style 3</NavLink></li>
                                             </ul>
                                          </Collapsible>

                                          <Collapsible trigger={<li className='border-0'><NavLink to="/homeThree">Home style 3</NavLink></li>} triggerTagName="div" triggerOpenedClassName="sub_child icon_close" triggerClassName="sub_child iconAdd" open={false}>
                                             <ul className="sidebar_sub_menu sub_child_menu submenu text-white">
                                                <li><NavLink to="/headerStyleFour">Header Syle 4</NavLink></li>
                                                <li><NavLink to="/headerStyleFive">Header Syle 5</NavLink></li>
                                                <li><NavLink to="/headerStyleSix">Header Syle 6</NavLink></li>
                                                <li><NavLink to="/headerStyleSeven">Header Syle 7</NavLink></li>
                                             </ul>
                                          </Collapsible>
                                       </ul>
                                    </Collapsible> */}






                                 

                                    {/* <Collapsible trigger={<NavLink to="/services">Services</NavLink>} triggerTagName="div"
                                       triggerOpenedClassName="icon_close" triggerClassName="iconAdd" open={false}>
                                          <ul className="sidebar_sub_menu submenu text-white">
                                             <li><NavLink to="/services">Services</NavLink></li>
                                             <li><NavLink to="/servicesDetails">Services Details</NavLink></li>
                                          </ul>
                                    </Collapsible> */}

                                    {/* <Collapsible trigger={<NavLink to="/portfolio">Insights</NavLink>} triggerTagName="div"
                                       triggerOpenedClassName="icon_close" triggerClassName="iconAdd" open={false}>
                                       <ul className="sidebar_sub_menu submenu text-white text-capitalize">
                                          <li><NavLink to="/portfolio">portfolio</NavLink></li>
                                          <li><NavLink to="/portfolioDetails">portfolio Details</NavLink></li>
                                          <li><NavLink to="/team">team</NavLink></li>
                                          <li><NavLink to="/teamDetails">team Details</NavLink></li>
                                       </ul>
                                    </Collapsible> */}

                                    {/* <Collapsible trigger={<NavLink to="/blogs">Blog</NavLink>} triggerTagName="div"
                                       triggerOpenedClassName="icon_close" triggerClassName="iconAdd" open={false}>
                                       <ul className="sidebar_sub_menu submenu text-white">
                                          <li><NavLink to="/blogs">Blog</NavLink></li>
                                          <li><NavLink to="/blogDetails">Blog Details</NavLink></li>
                                       </ul>
                                    </Collapsible> */}

                           

                                 </div>

                              </div>

                              <div className="tab-pane fade" id="info" role="tabpanel" aria-labelledby="info-tab">
                                 <div className="sidebar__info">
                                    {/* <div className="logo mb-40">
                                       <a href="index.html">
                                          <img src={`/assets/img/logo/${businessLogic.logoWhite}`} height={80} alt="logo"/>
                                       </a>
                                    </div> */}
                                    <p>{t("home_techgrid_text")}</p>
                                    <a href="/contact" className="z-btn z-btn-white">{t("contact_us")}</a>

                                    <a href={businessLogic.whatsappLink} target="_blank" rel="noreferrer" className="z-btn z-btn-transparent mt-15" style={{ backgroundColor: '#25D366' }} >WhatsApp</a>


                                    {/* <div className="sidebar__search">
                                       <form action="#">
                                          <input type="text" placeholder="Your Keywords.."/>
                                          <button type="submit"><i > <FaSearch /> </i></button>
                                       </form>
                                    </div> */}
                                    <div className="sidebar__contact mt-30">
                                       <ul>
                                          <li>
                                             <div className="icon">
                                                <i > <BiMap /> </i>
                                             </div>
                                             <div className="text">
                                             <span>{businessLogic.address}</span>
                                             </div>
                                          </li>
                                          <li>
                                             <div className="icon">
                                                <i > <FaEnvelope /> </i>
                                             </div>
                                             <div className="text ">
                                             <span><a href={`mailto:${businessLogic.emailBase}`}>{businessLogic.emailBase}</a></span>
                                             </div>
                                          </li>
                                          {businessLogic.phoneNumber ? (
                                          <li>
                                             <div className="icon">
                                                <i ><FaPhoneAlt /> </i>
                                             </div>
                                             <div className="text">
                                             <span><a href={`tel:${businessLogic.phoneNumber}`}>{businessLogic.phoneNumber}</a></span>
                                             </div>
                                          </li>
                                          ) : null}
                                       </ul>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </section>

               </Offcanvas.Body>
            </Offcanvas>
         </div>
      </>
   );
};

export default Sidebar;